export const selectAlarm = (state) => state.alarm
export const selectAlarmHistory = (state) => state.alarm.alarmEvents
